<template>
  <b-modal
    v-model="show"
    title="Preview Gambar"
    centered
    hide-footer
    size="xl"
    @hidden="clearBodyScrollbarPadding"
  >
    <div class="text-center" style="position: relative; width: 100%">
      <img :src="url" class="image" />
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modelValue: Boolean,
    url: String,
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
  methods: {
    clearBodyScrollbarPadding() {
      document.body.style.removeProperty("padding-right");
      document.body.removeAttribute("data-bs-padding-right");
    },
  },
};
</script>